import OptimizationChecklist from './OptimizationChecklist.component';

export default OptimizationChecklist;
